function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './PhoneWithCountrySelection.css';
import React, { useState, useRef } from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../../atoms/ComponentsWrapper';
import Select from 'react-select';
import { get, canUseDOM } from '../../../utils';
import { BASE_SINGLE_SELECT_PROPS } from '../../../utils/constants';
import 'react-dropdown/style.css';
import { rtlStyles, ltrStyles, commonStyles } from '../accountAuthorizationStyles';
const reactSelectSingleUiSettings = _objectSpread(_objectSpread({}, BASE_SINGLE_SELECT_PROPS), {}, {
  isSearchable: true
});
const PhoneWithCountrySelection = _ref => {
  let {
    name,
    value,
    changeEvent,
    blurEvent,
    label,
    id,
    options,
    labelLight,
    fieldError,
    autoComplete = 'off',
    required = false,
    placeholder,
    countryItems,
    maxLength,
    minLength,
    tooltip
  } = _ref;
  const [highLightText, setHighLightText] = useState(false);
  const [highLightDrop, setHighLightDrop] = useState(false);
  const [dropOpened, setDropOpened] = useState(false);
  const clickedTextRef = useRef(false);
  const dropFocusStampRef = useRef(0);
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  let countryItemsList = [...countryItems];
  const [indicatif, setIndicatif] = React.useState({
    label: {},
    value: ''
  });
  const [inputValue, setInputValue] = React.useState('');
  const [isInnerFieldsVisible, setIsInnerFieldsVisible] = React.useState(false);
  const [preselectedValue, setPreselectedValue] = React.useState([]);
  const selectIndicatif = e => {
    setDropOpened(false);
    setIndicatif(e);
    setHighLightDrop(false);
    changeEvent(`${e.value}|${inputValue}`);
  };
  React.useEffect(() => {
    let countryCode = '';
    if (canUseDOM) {
      var countryNameCookie = document.cookie.split(';').find(item => item.indexOf('user_country_code') > -1);
      if (countryNameCookie) {
        var countryName = countryNameCookie.replace('user_country_code=', '').trim();
        countryCode = countryName !== 'undefined' ? countryName.replace(/\s/g, '') : '';
      }
    }
    if (process.env.STORYBOOK_MODE) {
      countryCode = 'PK';
    }
    const serverCountry = rawCountryItems.find(item => item.code === countryCode) || rawCountryItems[0];
    setPreselectedValue([serverCountry]);
    setIndicatif(serverCountry);
  }, []);
  React.useEffect(() => {
    if (value) {
      const [countryCode, phoneNumber] = value.split('|');
      const selectedCountry = rawCountryItems.find(item => item.value === countryCode) || rawCountryItems[0];
      setPreselectedValue([selectedCountry]);
      setInputValue(phoneNumber ? phoneNumber : '');
      setIndicatif(selectedCountry);
      setIsInnerFieldsVisible(true);
    }
  }, [value]);
  const onChangeEvent = e => {
    const newValue = get(e, 'currentTarget.value');
    const safeValue = newValue ? newValue : '';
    setInputValue(safeValue);
    changeEvent(`${indicatif.value}|${safeValue}`);
  };
  const handleTextMousedown = () => {
    clickedTextRef.current = true;
  };
  const handleTextFocus = () => {
    if (!clickedTextRef.current) {
      setHighLightText(true);
    }
  };
  const handleTextBlur = () => {
    clickedTextRef.current = false;
    if (blurEvent) {
      blurEvent(inputValue);
    }
    setHighLightText(false);
  };
  const handleDropMousedown = () => {
    if (Date.now() - dropFocusStampRef.current < 10) {
      setHighLightDrop(false);
    }
    setDropOpened(!dropOpened);
  };
  const handleDropTouchstart = e => {
    const dropListTouched = !!e.target.closest('.select-dropdown__menu');
    if (!dropListTouched) {
      setDropOpened(!dropOpened);
    }
  };
  const handleDropFocus = () => {
    dropFocusStampRef.current = Date.now();
    setHighLightDrop(true);
  };
  const handleDropBlur = () => {
    setDropOpened(false);
    setHighLightDrop(false);
  };
  const handleDropKeyDown = e => {
    if (e.which === 13 || e.which === 32) {
      setDropOpened(!dropOpened);
      if (!dropOpened) {
        e.preventDefault();
      }
    }
    if (e.which === 27) {
      setDropOpened(false);
    }
  };
  const rawCountryItems = countryItemsList.map((country, index) => {
    return {
      label: /*#__PURE__*/React.createElement("span", {
        className: "select-item"
      }, country.flagSrc && /*#__PURE__*/React.createElement("img", {
        alt: country.code,
        className: "select-item__image",
        src: country.flagSrc
      }), ' ', /*#__PURE__*/React.createElement("span", {
        className: "select-item__text"
      }, country.text || '-')),
      listingLabel: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, country.countryName), " ", `(${country.value || '-'})`),
      value: get(country, 'value') || `${index}-`,
      code: get(country, 'code'),
      countryName: get(country, 'countryName')
    };
  });
  const fieldHasError = fieldError && fieldError.length;

  //Add your search logic here.
  const customFilter = (option, searchText) => {
    if (option.data.countryName.toLowerCase().includes(searchText.toLowerCase()) || option.data.value.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  };
  function handleWraperFocus(event) {
    if (!clickedTextRef.current) {
      setHighLightText(true);
    }
    setIsInnerFieldsVisible(true);
  }
  function handleWraperBlur(event) {
    clickedTextRef.current = false;
    setHighLightText(false);
  }
  const onKeyDownEvent = e => {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End', 'Enter', 'Escape'];
    if (e.ctrlKey && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) {
      return;
    }
    if (!/^[0-9]$/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group lr__form-group"
  }, /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    onBlur: handleWraperBlur,
    onFocus: handleWraperFocus,
    className: `
    form-input-div form-input lr__field input-text-primary
    ${isInnerFieldsVisible ? 'form-input--filled' : ''}
    ${fieldError && fieldError.length ? 'form-input--error' : ''}
  `
  }, isInnerFieldsVisible && /*#__PURE__*/React.createElement("div", {
    className: `input-wrapper ${dropOpened ? 'input-wrapper--opened' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-wrapper",
    onMouseDown: handleDropMousedown,
    onTouchStart: handleDropTouchstart
  }, preselectedValue.length && /*#__PURE__*/React.createElement(Select, _extends({}, reactSelectSingleUiSettings, {
    name: `code-${name}`,
    options: rawCountryItems,
    onChange: selectIndicatif,
    defaultValue: preselectedValue[0],
    className: `
        react-custom-select
        ${highLightDrop ? 'react-custom-select--outlined' : ''}
        ${fieldHasError ? 'react-custom-select--error' : ''}
        `,
    onFocus: handleDropFocus,
    onBlur: handleDropBlur,
    onKeyDown: handleDropKeyDown,
    menuIsOpen: dropOpened,
    "aria-label": label,
    "aria-labelledby": label,
    filterOption: customFilter,
    formatOptionLabel: (option, _ref2) => {
      let {
        context
      } = _ref2;
      return context === 'menu' ? option.listingLabel : option.label;
    }
  }))), /*#__PURE__*/React.createElement("input", {
    className: `
        input-text-inner
        numInput
        ${fieldHasError ? 'error-input' : ''}
        ${highLightText ? 'input-text-primary--focused' : ''}
      `,
    type: "number",
    onChange: onChangeEvent,
    placeholder: placeholder,
    maxLength: maxLength,
    minLength: minLength,
    name: name,
    value: inputValue,
    id: id,
    onMouseDown: handleTextMousedown,
    onKeyDown: onKeyDownEvent,
    onFocus: handleTextFocus,
    onBlur: handleTextBlur
  }))), /*#__PURE__*/React.createElement("label", {
    className: `form-label ${labelLight ? 'lr__label-light' : ''}`,
    htmlFor: id
  }, label, required ? /*#__PURE__*/React.createElement("strong", {
    className: "lr__red"
  }, "*") : '')), tooltip && /*#__PURE__*/React.createElement("span", {
    className: "tooltip-text"
  }, " ", tooltip), fieldError && fieldError.length ? /*#__PURE__*/React.createElement("div", {
    className: "lr__error"
  }, fieldError) : null);
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl
  } = _ref3;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    componentTabIndex: "disabled",
    className: ` ${rtl ? mainRtlStyles : mainLtrStyles} ${commonStyles}
      ${rtl ? rtlStyles : ltrStyles}
      ${styles}`
  }, children);
};
const styles = "svxsavs";
const mainLtrStyles = "ma0byj7";
const mainRtlStyles = "mof9zn6";
export default PhoneWithCountrySelection;